import React, { useEffect, useState } from "react";
import "../styles/ShippingPopup.css";
// import { getCountryCode } from "../utils/all.js";
import { fetchPickupPoint } from "../apis/apiBaltee.js";
import PickupPointList from "./PickupPointList.js";
import PickupPointMap from "./PickupPointMap.js";
import Loader from "./Loader.js";
import { X } from "lucide-react";

const ShippingPopup = ({ carrier, address, onSelect, onClose }) => {
  const [pickupPoints, setPickupPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewType, setViewType] = useState("list"); // "list" ou "map"

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const iso2CountryCode = await getCountryCode(address.country);
        const addressLong = `${address.street} ${address.postal_code} ${address.city}`;
        const data = await fetchPickupPoint(carrier, addressLong, 'FR');
        setPickupPoints(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des points relais :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [carrier, address]);

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="close-container" style={{textAlign: 'right'}}>
          <button onClick={onClose} className="cancel-btn">
            <X />
          </button>
        </div>
        <div className="view-toggle">
          <button
            onClick={() => setViewType("list")}
            className={viewType === "list" ? "active" : ""}
          >
            Liste
          </button>
          <button
            onClick={() => setViewType("map")}
            className={viewType === "map" ? "active" : ""}
          >
            Carte
          </button>
        </div>
        {loading ? (
          <Loader style={{minHeight: '70vh'}} />
        ) : (
          <>
            {viewType === "list" ? (
              <PickupPointList points={pickupPoints} onSelect={onSelect} />
            ) : (
              <PickupPointMap points={pickupPoints} onSelect={onSelect} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ShippingPopup;
